import { useState, useEffect } from 'react';
import useBackendApi from './useBackendApi';
import { AUTHENTICATED } from '../constants/user';
import { fetchUserMembershipSummary } from '../utils/userMembership';

const useOrgsAccts = (isUserDataReady, authStatus) => {
  const { apiFetchRequest } = useBackendApi();
  const [memberships, setMemberships] = useState([]);
  const [organizationMemberships, setOrganizationMemberships] = useState([]);
  const [isMembershipDataReady, setIsMembershipDataReady] = useState(false);

  useEffect(() => {
    if (!isUserDataReady || authStatus !== AUTHENTICATED) {
      return;
    }

    const fetchData = async () => {
      try {
        const membershipSummary = await fetchUserMembershipSummary(apiFetchRequest);

        if (!membershipSummary) {
          console.warn('Unable to fetch user memberships');
          setMemberships([]);
          setOrganizationMemberships([]);
        } else {
          setMemberships(membershipSummary.memberships);
          setOrganizationMemberships(membershipSummary.organizationMemberships);
        }
      } catch (error) {
        console.error('Failed to fetch auth home data:', error);
        setMemberships([]);
        setOrganizationMemberships([]);
      } finally {
        setIsMembershipDataReady(true);
      }
    };
    fetchData();
  }, [isUserDataReady, authStatus, apiFetchRequest]);

  return {
    memberships,
    organizationMemberships,
    isMembershipDataReady,
  };
};

export default useOrgsAccts;
